import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    fieldsFenceDestination,
    fieldsFencePoles,
    fieldFenceRailingMaterial,
    fieldsFenceFilling,
    fieldsFenceDimension,
    fieldsFenceMaterial,
} from './common/fieldsFence';

const FenceForm: IForm = {
    formId       : PublishedFormId.Fence,
    type         : FormTypeId.GlassAndMirror,
    thumbnailURL : '/resized-images/forms/fence.jpg',
    imagesURLs   : [
        '/resized-images/forms/description/fence/fence1.jpg',
        '/resized-images/forms/description/fence/fence2.jpg',
        '/resized-images/forms/description/fence/fence3.jpg',
        '/resized-images/forms/description/fence/fence4.jpg',
    ],
    fieldsOrder: [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.FenceDestination,
        IFormFieldKey.FencePoles,
        IFormFieldKey.FenceRailing,
        IFormFieldKey.FenceFilling,
        IFormFieldKey.FenceMaterial,
        IFormFieldKey.FenceSecondMaterial,
        IFormFieldKey.Dimension,
        IFormFieldKey.FenceProtection,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        fenceDestination    : fieldsFenceDestination,
        fencePoles          : fieldsFencePoles,
        fenceRailing        : fieldFenceRailingMaterial,
        fenceFilling        : fieldsFenceFilling,
        fenceMaterial       : fieldsFenceMaterial,
        fenceSecondMaterial : fieldsFenceMaterial,
        dimension           : fieldsFenceDimension,
        fenceProtection     : {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 1500,
            budgetMax          : 10000,
            budgetDefaultValue : 3000,
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default FenceForm;
